import { Columns } from '@shared/interfaces/table/column-config';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';

/**
 * MeteringPointSubtype Partial Translation Cell
 * Translates meteringPointSubtype enum into understandable values
 */
export const meteringPointSubtypePartial: Columns<any> = {
  title: 'Målepunktsart',
  key: 'meteringPointSubtype',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    notspecified: 'enum.meteringpoint.meteringpointsubtype.notspecified',
    physical: 'enum.meteringpoint.meteringpointsubtype.physical',
    virtual: 'enum.meteringpoint.meteringpointsubtype.virtual',
    calculated: 'enum.meteringpoint.meteringpointsubtype.calculated'
  }
}
